import React, { useState, useEffect, forwardRef } from 'react'
import { Container, Row, Col, Form, Button, Stack } from 'react-bootstrap'
import { submitContactUsForm, generateToken } from "../../services/NetworkCall"
import "react-toastify/dist/ReactToastify.css";
import { BsArrowClockwise } from "react-icons/bs";
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import AOS from 'aos';

const ContactUs = React.forwardRef((props, ref)  => {
    const [validated, setValidated] = useState(false);
    const [formData, setFormData] = useState({ "email": "", "phoneNumber": "", "message": "", "token": "", "answer": "" });
    const [loading, setLoading] = useState(false);
    const [captchaQuestion, setCaptchaQuestion] = useState("");
    const [error , setError] = useState({"answer":""});
 
    const handleSubmit = async (event) => {
        event.preventDefault();

        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            return; // Exit the function early if the form is invalid
        }

        setValidated(true);

        setLoading(true);
        // call the apis
        if (form.checkValidity() === true) {
            const res = await submitContactUsForm(formData);
            console.log(res);

            // Generate new token regardless of success or failure
            await generateNewToken();

            if (res.success) {
                alertSuccess();
                setValidated(false);
                form.reset(); // Use 'form' instead of 'event.target' for clarity
                setLoading(false);
                return;
            }
            else {
                res.message === "Incorrect Answer" ? setError({answer:"Invalid Captcha"}) :  alertError(res.mess);
               
            }
            setLoading(false);
        }
        setLoading(false)
    };

    // Helper function to generate new token and update state
    const generateNewToken = async () => {
        try {
            const response = await generateToken();
            setFormData(prev => ({
                ...prev,
                token: response.token,
                answer: "" // Clear previous answer
            }));
            setCaptchaQuestion(response.question);
        } catch (error) {
            console.error('Error generating token:', error);
        }
    };

    const inputHandler = (e) => {
        const { name, value } = e.target;
        setFormData((pre) => ({ ...pre, [name]: value }));
        {name == "answer" && setError((prev) => ({ ...prev, answer: "" })) }
    }


  
    // const captchaclick = ( value ) => {
    //     console.log("Captcha value:", value);
    // }


    const alertSuccess = () => {
        Swal.fire({
            title: 'Thank You! ',
            text: "You have nailed it! We are diving into your information and will be in touch soon!",
            icon: 'success',
            confirmButtonText: 'OK'
        });
    }

    const alertError = () => {
        Swal.fire({
            title: 'Oh oh!',
            text: 'It seems something went wrong. Please try again or email us at support@futurristic.com.',
            icon: 'warning',
            confirmButtonText: 'OK'
        });
    }

    useEffect(() => {
        AOS.init({ duration: 2000 })
        // Call generateToken when component mounts
        generateNewToken();
    }, []);


    return (
        <>
            <Container className='my-5'>
                <div className="FormContent" ref={ref} data-aos="fade-up">
                    <Row>
                        <Col md={12} lg={7} sm={12} >
                            <div className="FormHeading text-left ">
                                <h3 className='fontWeight-800'>Let's Connect to Explore Possibilites</h3>
                                <p>Didn’t find what you are looking for? Or want to discuss custom solutions? Let's connect!</p>
                            </div>

                            <div className="ContactInfo">
                                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                    <Row className="mb-3">
                                        <Form.Control type="hidden" name="token" value={formData.token} />
                                        <Form.Group className="mt-3" as={Col} md="12" controlId="validationCustom03">
                                            <Form.Label>Enter Email</Form.Label>
                                            <Form.Control type="email" pattern="[\w]+@[a-z]+\.[a-z]{2,3}" placeholder="Email address" required name="email" onChange={inputHandler} />
                                            <Form.Control.Feedback type="invalid" className='text-left'>
                                                Please enter a valid email.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mt-3" as={Col} md="12" controlId="validationCustom04">
                                            <Form.Label>Enter Your Mobile Number</Form.Label>
                                            <Form.Control type="text" pattern="[0-9+-]+" title="Please enter mobile number with country code." placeholder="Mobile number" required name='phoneNumber' onChange={inputHandler} />
                                            <Form.Control.Feedback type="invalid" className='text-left'>
                                                Please enter a valid mobile number.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mt-3" as={Col} md="12" controlId="validationCustom05">
                                            <Form.Label>Enter Your Message</Form.Label>
                                            <Form.Control as="textarea" rows={3} placeholder="Your message" required name='message' onChange={inputHandler} />
                                            <Form.Control.Feedback type="invalid" className='text-left'>
                                                Please enter a message.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mt-3" as={Col} md="12" controlId="validationCustom06">
                                            <Form.Label>Captcha Verification</Form.Label>
                                            <Stack direction='horizontal' gap={3} className='justify-content-center flex-sm-captcha align-items-start'>
                                                <Stack direction='horizontal' className='justify-content-between p-2 h-100 sm-py-3 bg-light rounded-2 w-50 w-sm-100 border-dashed'>
                                                    <span className='ms-5 fw-bold fs-3'> {captchaQuestion} </span> <span> <BsArrowClockwise className='fw-bolder' onClick={generateNewToken} /></span>
                                                </Stack>
                                                <div className='w-100'>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter your answer"
                                                        required
                                                        className='p-3'
                                                        name='answer'
                                                        onChange={inputHandler}
                                                        isInvalid={!!error.answer}
                                                    />
                                                    <Form.Control.Feedback type="invalid" className='text-left'>
                                                       {error.answer || "Please enter an answer for the captcha."}
                                                    </Form.Control.Feedback>
                                                </div>
                                            </Stack>
                                        </Form.Group>
                                         
                                        <Form.Group className="mt-3" as={Col} md="12" controlId="1">
                                            <Form.Check type='checkbox' id='contact-check' >
                                                <Form.Check.Input type='checkbox' name='agree' id='1' required />
                                                <Form.Check.Label className='text-dark'>I agree to <Link to='/termsandconditions' target='_blank' className='text-decoration-none'>Terms and Conditions</Link> and <Link to='/privacypolicy' target='_blank' className='text-decoration-none'>Privacy Policy .</Link></Form.Check.Label>
                                                <Form.Control.Feedback type="invalid"> You must agree before submitting.</Form.Control.Feedback>
                                            </Form.Check>
                                        </Form.Group> 
                                    </Row>
                                    <Button type="submit" size='md' variant="dark" className="ContactBtn px-5 rounded-5" disabled={loading}>Submit</Button>
                                </Form>
                            </div>
                        </Col>

                        <Col md={12} lg={5} sm={12} className='d-md-none d-lg-block'>
                            <div className="FormHeading text-left mt-5">
                                <img src="https://futurristic-prod.s3.ap-south-1.amazonaws.com/image/video/ContactUs.png" className="img-fluid rounded" alt="vision-pro-futurristic-" />
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </>
    )
});

export default ContactUs;
